import { Field } from 'formik';
import React from 'react';
import { Fieldset, Input } from '@fourthwall/components';
export const NumberForm = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "label", component: Input, label: "Label", placeholder: "Setting label" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "info", component: Input, label: "Info (optional)", placeholder: "Help text for this setting" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "default", component: Input, label: "Default Value (optional)", placeholder: "Default value" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "placeholder", component: Input, label: "Placeholder (optional)", placeholder: "Placeholder text" })))));
};
